import { TiLocale } from "../../types";
import zhCN from "./locales/zh-CN";
import enUS from "./locales/en-US";
import jaJP from "./locales/ja-JP";
const getLocale = () => {
  const lang = navigator.cookieEnabled && typeof localStorage !== "undefined" ? window.localStorage.getItem("umi_locale") : "";
  const isNavigatorLanguageValid = typeof navigator !== "undefined" && typeof navigator.language === "string";
  const browserLang = isNavigatorLanguageValid ? navigator.language.split("-").join("-") : "";
  return lang || browserLang || "zh-CN";
};
const getT = () => {
  const locale = getLocale();
  const locales = {
    [TiLocale.ZH_CN]: zhCN,
    [TiLocale.EN_US]: enUS,
    [TiLocale.JA_JP]: jaJP
  }[locale];
  return (text) => {
    return (locales == null ? void 0 : locales[text]) || text;
  };
};
export {
  getT
};
